export function compactDisplayUrl(url?: string) {
  if (!url) return ''
  try {
    const parsed = new URL(url)
    return `${parsed.hostname.replace(/^www\./i, '')}${parsed.pathname === '/' ? '' : parsed.pathname}`.replace(/\/$/, '')
  } catch {
    return url.replace(/^https?:\/\//i, '').replace(/\/$/, '')
  }
}

export function formatDisplayDate(value?: string) {
  if (!value) return '-'
  const datePart = value.match(/^\d{4}-\d{2}-\d{2}/)?.[0]
  if (datePart) return datePart

  const date = new Date(value)
  if (!Number.isNaN(date.getTime())) {
    return date.toISOString().slice(0, 10)
  }
  return value.split(/[T\s]/)[0] || value
}
